export default "__VITE_ASSET__DJQg0lLx__"